import { CheckCircle, Clock } from "lucide-react";

const transferData = [
  {
    id: 1,
    owner: "Fatima Noor",
    cause: "Medical Aid",
    bank: "HDFC Bank",
    account: "**** 4521",
    amount: 120000,
    status: "pending",
  },
  {
    id: 2,
    owner: "Ahmed Khan",
    cause: "Water Relief",
    bank: "SBI",
    account: "**** 7782",
    amount: 80000,
    status: "completed",
  },
];

const FundTransferList = () => {
  return (
    <div className="allcause-page">
      <header className="page-header">
        <h2>Fund Transfers</h2>
        <p>Track admin-to-cause owner transfers</p>
      </header>

      <div className="allcause-card">
        <table className="allcause-table">
          <thead>
            <tr>
              <th>Cause Owner</th>
              <th>Cause</th>
              <th>Bank</th>
              <th>Account</th>
              <th>Total Amount</th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody>
            {transferData.map((transfer) => (
              <tr key={transfer.id}>
                <td>{transfer.owner}</td>
                <td>{transfer.cause}</td>
                <td>{transfer.bank}</td>
                <td>{transfer.account}</td>
                <td className="amount">₹{transfer.amount}</td>
                <td>
                  {transfer.status === "completed" ? (
                    <span className="status approved">
                      <CheckCircle size={14} /> Completed
                    </span>
                  ) : (
                    <span className="status pending">
                      <Clock size={14} /> Pending
                    </span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default FundTransferList;
